import { api } from '../api';

export const updateNotificationsAsRead = async () => {
  await api.put('/notifications/all/read');
};
